module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section07_05_american-village-817947655322dcc688fe99a8f8c69da4.jpg";